function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1008 324L504 792 0 324l108-108 396 378 396-378z",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.2,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1010 1010"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/angle-down.fe346849.svg";
export { SvgComponent as ReactComponent };